import { defineStore } from 'pinia'

export const useValidationStore = defineStore('ValidationStore', {
  state: () => ({
    validatables: {},
    errors: {},
  }),
  getters: {
    hasErrors(state) {
      return (key) => state.errors[key]?.length > 0
    },
    getErrors(state) {
      return (key) => {
        return state.errors[key] || []
      }
    },
  },
  actions: {
    registerValidationFunction(key, validationFunc) {
      this.validatables[key] = validationFunc
    },
    addError(key, error) {
      if (typeof this.errors[key] === 'undefined') {
        this.errors[key] = []
      }
      this.errors[key].push(error)
      this._setErrors(this.errors)
    },
    validate(key) {
      this.clearErrors(key)
      this.validatables[key]()
    },
    clearErrors(key) {
      delete this.errors[key]
      this._setErrors(this.errors)
    },
    _setErrors(errors) {
      this.errors = { ...errors } // force reactivity
    },
  },
})
